<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <h4 class="mb-0" v-if="parameters.remitFromOrder">Pendientes de remitir</h4>
          <ModuleViewHeading v-if="parameters.remitFromSale" :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 180px; max-width: 250px;"><label class="filter-label">Zona</label><v-select :options="arr.filters.zone" v-model="filters.zone" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;"><label class="filter-label">Clientes</label><v-select :options="arr.filters.customers" v-model="filters.customers" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;"><label class="filter-label">Punto de venta</label><v-select :options="arr.filters.points_sales" v-model="filters.points_sales" :multiple="false" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="loadCustomers" v-b-tooltip.hover title="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col v-if="showCustomers" lg="3" class="mb-3 mb-lg-0">
          <b-card no-body class="pending-remits-tree-card">
            <div class="pending-remits-panel-title">
              <span><AppIcon name="group" /> Clientes pendientes</span>
              <b-button variant="link" class="pending-remits-tree-toggle" size="sm" v-b-tooltip.hover title="Ocultar clientes pendientes" aria-label="Ocultar clientes pendientes" @click="showCustomers = false"><AppIcon name="chevron_left" /></b-button>
            </div>
            <div class="pending-remits-tree">
            <vue-tree-list
              @click="selectedItem"              
              :model="customersTree"
              v-bind:default-expanded="false"              
            >                      
              <template v-slot:leafNameDisplay="slotProps">                
                <span>
                  &nbsp;&nbsp;{{ slotProps.model.name }}
                </span>
              </template>              

              <span class="icon" slot="treeNodeIcon"><AppIcon name="location_off" />&nbsp;</span>
              <span class="icon" slot="leafNodeIcon"><AppIcon name="business" />&nbsp;</span>
            </vue-tree-list>                     

            <EmptyState v-if="customers && !customers.length" icon="group" title="No hay clientes pendientes" />
            </div>
          </b-card>          
        </b-col>
        <div v-else class="pending-remits-tree-collapsed-bar" v-b-tooltip.hover.right title="Mostrar clientes pendientes" @click="showCustomers = true">
          <AppIcon name="chevron_right" />
          <span>Clientes pendientes</span>
        </div>
        <b-col :lg="showCustomers ? 9 : 12" :class="{ 'pending-remits-table-expanded': !showCustomers }">
          <b-card no-body>
            <b-row>
              <b-col sm="12">
                <b-overlay :show="overlay.remits" rounded="sm">
                  <b-table-simple class="app-table pending-remits-table mb-0" hover caption-top responsive v-if="arr.pending.length && !isMobileViewport">
                    <b-thead>
                      <b-tr v-if="parameters.remitMultipleItems">                                       
                        <b-th width="10%" class="text-left">Empresa</b-th>
                        <b-th width="10%" class="text-left">Fecha</b-th>
                        <b-th width="15%" class="text-left">Comprobante</b-th>
                        <b-th width="7%" class="text-left">Código</b-th>
                        <b-th width="28%" class="text-left">Descripción</b-th>
                        <b-th width="6%" class="text-center">Estado Vto.</b-th>
                        <b-th width="8%" class="text-center">Cantidad</b-th>
                        <b-th width="8%" class="text-center">Remitido</b-th>
                        <b-th width="8%" class="text-center">Pendiente</b-th>                                            
                      </b-tr>
                      <b-tr v-else>
                        <b-th width="10%" class="text-left">Empresa</b-th>
                        <b-th width="10%" class="text-left">Fecha</b-th>
                        <b-th width="15%" class="text-left">Comprobante</b-th>
                        <b-th width="65%" class="text-center">Productos</b-th>
                      </b-tr>
                    </b-thead>      
                    <b-tbody v-for="item in arr.pending" :key="item.id"> 
                      <b-tr v-if="parameters.remitMultipleItems" :variant="getVariant(item)">                                       
                        <b-th class="text-left align-middle">                        
                          <div v-if="parameters.remitFromSale">
                            {{item.sale.point_sale.business.reference}}                        
                          </div>
                          <div v-if="parameters.remitFromOrder">
                            {{item.order.points_sales.business.reference}}                        
                          </div>
                        </b-th>

                        <b-th class="text-left align-middle">                        
                          <div v-if="parameters.remitFromSale">
                            {{moment(item.sale.date).format('DD/MM/YYYY')}}                        
                          </div>
                          <div v-if="parameters.remitFromOrder">
                            {{moment(item.order.date).format('DD/MM/YYYY')}}                        
                          </div>
                        </b-th>

                        <b-th class="text-left align-middle">
                          <div v-if="parameters.remitFromSale">
                            <div v-if="item.sale.type_voucher && item.sale.point_sale">                          
                              {{item.sale.type_voucher.name}}
                              {{item.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.sale.number.toString().padStart(8,'0')}}
                            </div>
                          </div>
                          <div v-if="parameters.remitFromOrder">
                            <div v-if="item.order.points_sales">                              
                              PEDIDO 
                              {{item.order.points_sales.point_sale.toString().padStart(4,'0') + '-' + item.order.id.toString().padStart(8,'0')}}                                                 
                            </div>
                          </div>                                                                        
                        </b-th>

                        <b-td class="text-left align-middle">{{item.selectProduct.code}}</b-td>

                        <b-td class="text-left align-middle">
                          <div v-if="parameters.remitFromSale">
                            {{item.description}}
                          </div>
                          <div v-if="parameters.remitFromOrder">
                            {{item.selectProduct.name}}
                          </div>
                        </b-td>

                        <b-td class="text-center align-middle">
                          <div v-if="parameters.remitFromSale && item.vto.days">
                            {{item.vto.status}}
                          </div>
                        </b-td>

                        <b-td class="text-center align-middle">
                          {{item.quantity}}
                          <span v-if="item.unit_measurement">{{item.unit_measurement.reference}}</span>
                        </b-td>                      
                        <b-td class="text-center align-middle">
                          {{item.quantity_remit}}
                          <span v-if="item.unit_measurement">{{item.unit_measurement.reference}}</span>
                        </b-td>                      
                        <b-td class="text-center align-middle">
                          {{parseFloat(item.quantity) - parseFloat(item.quantity_remit)}}
                          <span v-if="item.unit_measurement">{{item.unit_measurement.reference}}</span>
                        </b-td>                      
                      </b-tr>

                      <b-tr v-else>
                        <b-th class="text-left align-middle">   
                          <div v-if="parameters.remitFromSale">                     
                            {{item.point_sale.business.reference}}                        
                          </div>
                          <div v-if="parameters.remitFromOrder">
                            {{item.points_sales.business.reference}}                        
                          </div>
                        </b-th>

                        <b-th class="text-left align-middle">                        
                          {{moment(item.date).format('DD/MM/YYYY')}}                        
                        </b-th>

                        <b-th class="text-left align-middle">
                          <div v-if="parameters.remitFromSale">
                            <div v-if="item.type_voucher && item.point_sale">                          
                              {{item.type_voucher.name}}
                              {{item.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')}}
                            </div>
                          </div>
                          <div v-if="parameters.remitFromOrder">
                            <div v-if="item.points_sales">                              
                              PEDIDO 
                              {{item.points_sales.point_sale.toString().padStart(4,'0') + '-' + item.id.toString().padStart(8,'0')}}                            
                            </div>
                          </div>                                                                        
                        </b-th>     

                        <b-td class="text-center align-middle">
                          <b-table-simple class="app-table app-table--compact mb-0" hover small caption-top responsive v-if="item.details.length">
                            <b-thead>
                              <b-tr>              
                                <b-th width="5%" class="text-left">Código</b-th>
                                <b-th width="35%" class="text-left">Descripción</b-th>
                                <b-th width="10%" class="text-center">Cantidad</b-th>
                                <b-th width="10%" class="text-center">Remitido</b-th>
                                <b-th width="10%" class="text-center">Pendiente</b-th>                                                            
                              </b-tr>
                            </b-thead>
                            <b-tbody v-for="item1 in item.details" :key="item1.id"> 
                              <b-tr v-if="parameters.remitFromSale" :class="{'table-success':parseFloat(item1.quantity) == parseFloat(item1.quantity_remit), 'table-warning':parseFloat(item1.quantity) != parseFloat(item1.quantity_remit)}">                            
                                <b-td class="text-left align-middle">{{item1.selectProduct.code}}</b-td>
                                <b-td class="text-left align-middle">{{item1.description}}</b-td>
                                <b-td class="text-center align-middle">
                                  {{item1.quantity}}
                                  <span v-if="item1.unit_measurement">{{item1.unit_measurement.reference}}</span>
                                </b-td>                      
                                <b-td class="text-center align-middle">
                                  {{item1.quantity_remit}}
                                  <span v-if="item1.unit_measurement">{{item1.unit_measurement.reference}}</span>
                                </b-td>                      
                                <b-td class="text-center align-middle">
                                  {{parseFloat(item1.quantity) - parseFloat(item1.quantity_remit)}}
                                  <span v-if="item1.unit_measurement">{{item1.unit_measurement.reference}}</span>
                                </b-td>                                 
                              </b-tr>
                              <b-tr v-if="parameters.remitFromOrder" :class="{'table-success':parseFloat(item1.quantity) == parseFloat(item1.quantity_remit), 'table-warning':parseFloat(item1.quantity) != parseFloat(item1.quantity_remit)}">                            
                                <b-td class="text-left align-middle">{{item1.selectProduct.code}}</b-td>
                                <b-td class="text-left align-middle">{{item1.selectProduct.name}}</b-td>
                                <b-td class="text-center align-middle">
                                  {{item1.quantity}}
                                  <span v-if="item1.unit_measurement">{{item1.unit_measurement.reference}}</span>
                                </b-td>                      
                                <b-td class="text-center align-middle">
                                  {{item1.quantity_remit}}
                                  <span v-if="item1.unit_measurement">{{item1.unit_measurement.reference}}</span>
                                </b-td>                      
                                <b-td class="text-center align-middle">
                                  {{parseFloat(item1.quantity) - parseFloat(item1.quantity_remit)}}
                                  <span v-if="item1.unit_measurement">{{item1.unit_measurement.reference}}</span>
                                </b-td>                                 
                              </b-tr>                            
                            </b-tbody>
                          </b-table-simple>
                        </b-td>                                       
                      </b-tr>
                    </b-tbody>                              
                  </b-table-simple>
                  <div v-else-if="arr.pending.length" class="pending-remits-mobile-list">
                    <article v-for="item in arr.pending" :key="item.id" class="pending-remits-mobile-card">
                      <div class="pending-remits-mobile-card__header">
                        <span v-if="parameters.remitFromSale">{{ item.sale.point_sale.business.reference }}</span>
                        <span v-if="parameters.remitFromOrder">{{ parameters.remitMultipleItems ? item.order.points_sales.business.reference : item.points_sales.business.reference }}</span>
                      </div>

                      <template v-if="parameters.remitMultipleItems">
                        <dl class="pending-remits-mobile-card__fields">
                          <div><dt>Fecha</dt><dd>{{ moment(parameters.remitFromSale ? item.sale.date : item.order.date).format('DD/MM/YYYY') }}</dd></div>
                          <div><dt>Comprobante</dt><dd v-if="parameters.remitFromSale && item.sale.type_voucher && item.sale.point_sale">{{ item.sale.type_voucher.name }} {{ item.sale.point_sale.point_sale.toString().padStart(4, '0') + '-' + item.sale.number.toString().padStart(8, '0') }}</dd><dd v-else-if="parameters.remitFromOrder && item.order.points_sales">PEDIDO {{ item.order.points_sales.point_sale.toString().padStart(4, '0') + '-' + item.order.id.toString().padStart(8, '0') }}</dd></div>
                          <div><dt>Producto</dt><dd>{{ item.selectProduct.code }} · {{ parameters.remitFromSale ? item.description : item.selectProduct.name }}</dd></div>
                          <div v-if="parameters.remitFromSale && item.vto.days"><dt>Estado de vencimiento</dt><dd>{{ item.vto.status }}</dd></div>
                          <div><dt>Cantidad</dt><dd>{{ item.quantity }} <span v-if="item.unit_measurement">{{ item.unit_measurement.reference }}</span></dd></div>
                          <div><dt>Remitido</dt><dd>{{ item.quantity_remit }} <span v-if="item.unit_measurement">{{ item.unit_measurement.reference }}</span></dd></div>
                          <div><dt>Pendiente</dt><dd>{{ parseFloat(item.quantity) - parseFloat(item.quantity_remit) }} <span v-if="item.unit_measurement">{{ item.unit_measurement.reference }}</span></dd></div>
                        </dl>
                      </template>

                      <template v-else>
                        <dl class="pending-remits-mobile-card__fields">
                          <div><dt>Fecha</dt><dd>{{ moment(item.date).format('DD/MM/YYYY') }}</dd></div>
                          <div><dt>Comprobante</dt><dd v-if="parameters.remitFromSale && item.type_voucher && item.point_sale">{{ item.type_voucher.name }} {{ item.point_sale.point_sale.toString().padStart(4, '0') + '-' + item.number.toString().padStart(8, '0') }}</dd><dd v-else-if="parameters.remitFromOrder && item.points_sales">PEDIDO {{ item.points_sales.point_sale.toString().padStart(4, '0') + '-' + item.id.toString().padStart(8, '0') }}</dd></div>
                        </dl>
                        <div class="pending-remits-mobile-card__details" v-if="item.details.length">
                          <div v-for="detail in item.details" :key="detail.id" class="pending-remits-mobile-product">
                            <strong>{{ detail.selectProduct.code }} · {{ parameters.remitFromSale ? detail.description : detail.selectProduct.name }}</strong>
                            <span>Cantidad: {{ detail.quantity }} <template v-if="detail.unit_measurement">{{ detail.unit_measurement.reference }}</template></span>
                            <span>Remitido: {{ detail.quantity_remit }} <template v-if="detail.unit_measurement">{{ detail.unit_measurement.reference }}</template></span>
                            <span>Pendiente: {{ parseFloat(detail.quantity) - parseFloat(detail.quantity_remit) }} <template v-if="detail.unit_measurement">{{ detail.unit_measurement.reference }}</template></span>
                          </div>
                        </div>
                      </template>
                    </article>
                  </div>
                  <EmptyState v-else icon="inventory_2" title="No hay productos para remitir" />
                </b-overlay>              
              </b-col>
            </b-row>
            <div class="app-table-footer pending-remits-table-footer" v-if="arr.pending.length">
              <span>{{ arr.pending.length }} registros</span>
              <export-excel class="list-view-link" :data="arr.export" worksheet="Listado de Pendiente a Remitir" name="list-pending-remits.xls"><AppIcon name="download" class="mr-1" /> Exportar</export-excel>
            </div>
          </b-card>
        </b-col>
      </b-row>    

      <b-row>
        <b-col lg="12">  
          <b-card body-class="py-2">
            <b-row>
              <b-col>
                <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                  <AppIcon name="back" class="mr-1" />
                  Volver
                </b-button>                        
              </b-col>        
            </b-row>
          </b-card>
        </b-col>
      </b-row>     
    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Funciones from '@/handler/funciones' 
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'   
  import Param from '@/config/parameters'
  import moment from 'moment'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  
  import Vue from 'vue'
  import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'
  Vue.use(VueTreeList)  

  export default {
    components: {
      VueTreeList,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.REMITOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'pending',
          elements: {}
        },            
        parameters: {
          remitFromOrder: Helper.hasParametersAccess(Param.P26),
          remitFromSale: Helper.hasParametersAccess(Param.P27),
          remitMultipleItems: Helper.hasParametersAccess(Param.P28),
        },                    
        arr: {
          export: [],     
          pending: [],
          filters : {
            zone: [],
            customers: [],            
            points_sales: [],
          },                                
        },           
        filters: {
          zone: null,
          customers: null,
          points_sales: null,
        },    
        customers: null,
        customersTree: new Tree([]),                   
        filtersOpen: false,
        showCustomers: true,
        isMobileViewport: false,
        mobileMql: null,
        overlay: {
          remits: false
        }
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },     
    mounted() {         
      this.filtersOpen = StorageLocal.getValue('filters_open_pending_remits') == 'true'
      this.showCustomers = StorageLocal.getValue('pending_remits_customers_open') != 'false'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadCustomers()      
      this.filterLoad()      

      this._start = true
    },        
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 
            
      this.loadCustomers()      
      this.filterLoad()        
    },       
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_pending_remits', value ? 'true' : 'false')
      },
      showCustomers(value) {
        StorageLocal.setValue('pending_remits_customers_open', value ? 'true' : 'false')
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      // EXPORTAR
      prepareExport(data) {        
        this.arr.export = []
        data.forEach(element => {
            var item = null
            if(this.parameters.remitMultipleItems) {
              if(element.order) {
                item = element.order                
              } 
              if(element.sale) {
                item = element.sale
              }      
            } else {
              item = element
            }

            var businessID = 0
            var businessName = ""
            var customersID = 0
            var customersCode = ""
            var customersName = ""
            var voucherReference = ""
            var productID = 0
            var productCode = ""
            var productName = ""
            var productCompoundID = 0
            var productCompoundName = ""     
            var unitMeasurementID = 0
            var unitMeasurementName = ""
            var quantity = 0
            var quantity_remit = 0     
            var vto_days = 0
            var vto_status = ''
                        
            if(item.point_sale && item.point_sale.business) {
              businessID = item.point_sale.business.id            
              businessName = item.point_sale.business.reference
            } else if(item.points_sales && item.points_sales.business) {
              businessID = item.points_sales.business.id            
              businessName = item.points_sales.business.reference              
            }            
            if(item.customer) {
              customersID = item.customer.id
              customersCode = item.customer.code
              customersName = item.customer.name            
            }
            if(item.type_voucher) {            
              if(item.point_sale) {
                voucherReference = item.type_voucher.name + ' ' + item.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')
              } 
            } else {
              if(item.points_sales) {
                voucherReference = 'PEDIDO ' + item.points_sales.point_sale.toString().padStart(4,'0') + '-' + item.id.toString().padStart(8,'0')
              }              
            }    
                        
            var arrDetail = []
            if(element.details) {
              arrDetail = element.details
            } else {
              arrDetail.push(element) 
            }

            arrDetail.forEach(element1 => {
              if(element1.products_id) {
                productID = element1.product.id
                productCode = element1.product.code
                productName = element1.product.name            
              }

              if(element1.products_colors_id) {
                productID = element1.products_color.id
                productCode = element1.products_color.code
                productName = element1.products_color.name + " (" + element1.products_color.color.name + ")"
              }            

              if(element1.products_waist_id) {
                productID = element1.products_waist.id
                productCode = element1.products_waist.code
                productName = element1.products_waist.name + " (" + element1.products_waist.waist.name + ")"
              }            

              if(element1.products_color_waist_id) {
                productID = element1.products_color_waist.id
                productCode = element1.products_color_waist.code
                productName = element1.products_color_waist.name + " (" + element1.products_color_waist.color.name + " - " + element1.products_color_waist.waist.name + ")"
              }       

              if(element1.products_compound_id) {
                productCompoundID = element1.products_compound.id
                productCompoundName = element1.products_compound.name            
              }    
              
              if(element1.unit_measurement_id) {
                unitMeasurementID = element1.unit_measurement.id
                unitMeasurementName = element1.unit_measurement.name            
              }            
              
              quantity = element1.quantity
              quantity_remit = element1.quantity_remit

              vto_days = 0
              vto_status = ''
              if(element1.vto) {
                vto_days = element1.vto.days
                vto_status = element1.vto.status
              }
            });

            this.arr.export.push({
              id: element.id,
              businessID: businessID,
              businessName: businessName,              
              date: item.date,    
              voucherReference: voucherReference,          
              customersID: customersID,
              customersCode: customersCode,
              customersName: customersName,                   
              observations: item.observations,
              productID: productID,
              productCode: productCode,
              productName: productName,
              productCompoundID: productCompoundID,
              productCompoundName: productCompoundName,                                          
              quantity: quantity,
              quantityRemit: quantity_remit,
              quantityPending: parseFloat(quantity) - parseFloat(quantity_remit),
              unitMeasurementID: unitMeasurementID,
              unitMeasurementName: unitMeasurementName,  
              vto_days: vto_days,
              vto_status: vto_status,
            })            
          });
      },
      
      // FILTER
      filterLoad() {   
        this.filterLoadZone()          
        this.filterLoadCustomers()          
        this.filterLoadPointSale()                        
      },
      filterLoadZone() {
        var result = serviceAPI.obtenerZona()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.zone = []
          data.forEach(element => {            
            this.arr.filters.zone.push({ code: element.id, label: element.name })            
          });          
        })   
      },      
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.customers = []
          data.forEach(element => {          
            if(element.code) {
              this.arr.filters.customers.push({ code: element.id, label: element.code + ' | ' + element.name })            
            } else {
              this.arr.filters.customers.push({ code: element.id, label: element.name })            
            }                            
          });          
        })   
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.points_sales = []
          data.forEach(element => {                            
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })            
          });          
        })   
      },       
        
      // TREE
      loadCustomers() {
        if(this.parameters.remitMultipleItems) {
          this.loadCustomersMultipleItems()
        } else {
          this.loadCustomersGroupItems()
        }              
      },
      loadCustomersMultipleItems() {
        let loader = this.$loading.show()   
        
        var result = serviceAPI.filtrarPendienteRemitir(this.filters)
        
        result.then((response) => {
          loader.hide()

          this.arr.pending = [];
          this.customers = [];  
          this.customersTree = new Tree(this.customers);  

          var data = response.data
          if(data.length) {
            var arrZone = []
            data.forEach(element => {
              var zone_id = 0
              var zone_name = 'SIN ZONA'
              if(element.sale) {
                if(element.sale.customer.zone) {
                  zone_id = element.sale.customer.zone.zone.id
                  zone_name = element.sale.customer.zone.zone.name
                }
              }
              if(element.order) {
                if(element.order.customer.zone) {
                  zone_id = element.order.customer.zone.zone.id
                  zone_name = element.order.customer.zone.zone.name
                }
              }              

              if(element.sale) {
                arrZone.push({
                  id: zone_id,
                  name: zone_name,
                  customer: {
                    id: element.sale.customer.id,
                    name: element.sale.customer.name,
                  }
                })                
              }
              
              if(element.order) {
                arrZone.push({
                  id: zone_id,
                  name: zone_name,
                  customer: {
                    id: element.order.customer.id,
                    name: element.order.customer.name,
                  }
                })
              }

            });
              
            arrZone = Funciones.sortArrayInteger(arrZone,'id','asc')              
            
            var groupZone = []            
            arrZone.forEach(element => {
              if(groupZone[element.id] == undefined) {
                groupZone[element.id] = [] 
                groupZone[element.id].id = element.id
                groupZone[element.id].name = element.name
                groupZone[element.id].children = []
              }
            });            
            groupZone = groupZone.filter(Boolean)
            
            this.configTree(groupZone, arrZone)
          }           
        })
        .catch(error => {                
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });    
      },
      loadCustomersGroupItems() {
        let loader = this.$loading.show()   
        
        var result = serviceAPI.filtrarVoucherPendienteRemitir(this.filters)
        
        result.then((response) => {
          loader.hide()

          this.arr.pending = [];
          this.customers = [];  
          this.customersTree = new Tree(this.customers);  

          var data = response.data
          if(data.length) {
            var arrZone = []
            data.forEach(element => {
              var zone_id = 0
              var zone_name = 'SIN ZONA'
              if(element.customer.zone) {
                zone_id = element.customer.zone.zone.id
                zone_name = element.customer.zone.zone.name
              }

              arrZone.push({
                id: zone_id,
                name: zone_name,
                customer: {
                  id: element.customer.id,
                  name: element.customer.name,
                }
              })
            });
              
            arrZone = Funciones.sortArrayInteger(arrZone,'id','asc')              
            
            var groupZone = []            
            arrZone.forEach(element => {
              if(groupZone[element.id] == undefined) {
                groupZone[element.id] = [] 
                groupZone[element.id].id = element.id
                groupZone[element.id].name = element.name
                groupZone[element.id].children = []
              }
            });            
            groupZone = groupZone.filter(Boolean)
            
            this.configTree(groupZone, arrZone)
          }           
        })
        .catch(error => {         
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });    
      },

      configTree(group, data) { 
        this.customers = []             

        group.forEach((element, index) => {                                                          
          this.customers.push({            
            id: element.id,                  
            name: element.name,            
            dragDisabled: true,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,                     
            children: [],
          })

          this.getChildren(this.customers[index], data)
        })                  

        this.customersTree = new Tree(this.customers)
      },         
      getChildren(obj, data) {                                     
        if(data) {        
          data.forEach(element => {        
            if(obj.id == element.id) {

              var existe = false
              obj.children.forEach(item => {
                if(item.id == element.customer.id) {
                  existe = true
                }
              });

              if(!existe) {
                obj.children.push({
                  id: element.customer.id,      
                  name: element.customer.name,                
                  dragDisabled: true,
                  addTreeNodeDisabled: true,
                  addLeafNodeDisabled: true,
                  editNodeDisabled: true,
                  delNodeDisabled: true,                  
                  isLeaf: true,                            
                })    
              }                                  
            }  
          });     
        }   
      },      
      selectedItem(params) {     
        if(params.isLeaf) {
          this.obtenerPendienteRemitirByCliente(params.id)
        }        
      },

      // PENDING 
      obtenerPendienteRemitirByCliente(customer_id) {
        this.overlay.remits = true

        if(this.parameters.remitMultipleItems) {
          var result = serviceAPI.filtrarPendienteRemitir({'customers_id':customer_id})        
          result.then((response) => {
            var data = response.data
            this.overlay.remits = data.length > 0

            this.arr.pending = data             
            this.prepareExport(data)

            this.overlay.remits = false
          })                   
        } else {
          var result = serviceAPI.filtrarVoucherPendienteRemitir({'customers_id':customer_id})        
          result.then((response) => {
            var data = response.data  
            this.overlay.remits = data.length > 0

            this.arr.pending = data 
            this.prepareExport(data)

            this.overlay.remits = false
          })                   
        }                 
      },   
      getVariant(item) {
        var alert = ''
        if(this.parameters.remitFromSale) {
          alert = item.vto.alert
        }        
        return alert                
      }     
    }
  }
</script>
<style scoped>
  .pending-remits-panel-title {
    align-items: center;
    border-bottom: 1px solid var(--app-color-border);
    color: var(--app-color-text);
    display: flex;
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    gap: 7px;
    padding: 12px;
  }
  .pending-remits-panel-title > span { align-items: center; display: inline-flex; gap: 7px; }
  .pending-remits-panel-title .material-symbols-rounded { color: var(--app-color-primary); }
  .pending-remits-tree-toggle.btn { align-items: center; border: 0; border-radius: 5px; color: var(--app-color-text-secondary); display: inline-flex; height: 25px; justify-content: center; margin: -4px -5px -4px auto; padding: 0; width: 25px; }
  .pending-remits-tree-toggle.btn .material-symbols-rounded { color: inherit; }
  .pending-remits-tree-toggle.btn:hover,
  .pending-remits-tree-toggle.btn:focus { background: var(--app-color-primary-soft); color: var(--app-color-primary-active); }
  .pending-remits-tree-collapsed-bar { align-items: center; background: var(--app-color-surface-subtle); border: 1px solid var(--app-color-border-strong); border-radius: 6px; color: var(--app-color-text-secondary); cursor: pointer; display: flex; flex-direction: column; margin: 0 15px 1rem; min-height: 200px; padding: 14px 5px; transition: background-color 0.15s, color 0.15s; width: 32px; }
  .pending-remits-tree-collapsed-bar:hover { background: var(--app-color-primary-soft); color: var(--app-color-primary-active); }
  .pending-remits-tree-collapsed-bar > .material-symbols-rounded { font-size: 18px; margin-bottom: 8px; }
  .pending-remits-tree-collapsed-bar span { font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); letter-spacing: 0.02em; text-orientation: mixed; writing-mode: vertical-rl; }
  .pending-remits-table-expanded { flex: 1; max-width: calc(100% - 62px); }
  .pending-remits-tree { max-height: 60vh; overflow: auto; padding: 8px 12px 12px; }
  .pending-remits-tree >>> .icon .material-symbols-rounded { color: var(--app-color-primary); font-size: 17px; vertical-align: -3px; }
  .pending-remits-tree >>> .vtl { font-size: var(--app-text-sm); }
  .pending-remits-tree >>> .vtl-node-content {
    border-radius: 6px;
    color: var(--app-color-text-secondary);
    margin: 2px 0;
    padding: 5px 4px;
  }
  .pending-remits-tree >>> .vtl-node-content:hover { background: var(--app-color-primary-soft); color: var(--app-color-primary-active); }
  .pending-remits-table-footer { padding-right: 12px; }
  .pending-remits-table th,
  .pending-remits-table td { padding: 0.55rem 0.6rem; }
  .pending-remits-mobile-list { display: grid; gap: 10px; padding: 12px; }
  .pending-remits-mobile-card { border: 1px solid var(--app-color-border); border-radius: 8px; overflow: hidden; }
  .pending-remits-mobile-card__header { background: var(--app-color-surface-subtle); color: var(--app-color-text); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); padding: 9px 10px; }
  .pending-remits-mobile-card__fields { margin: 0; padding: 4px 10px; }
  .pending-remits-mobile-card__fields > div { border-bottom: 1px solid var(--app-color-border); display: grid; gap: 4px; grid-template-columns: minmax(104px, 38%) 1fr; padding: 7px 0; }
  .pending-remits-mobile-card__fields > div:last-child { border-bottom: 0; }
  .pending-remits-mobile-card dt { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); margin: 0; text-transform: uppercase; }
  .pending-remits-mobile-card dd { color: var(--app-color-text); font-size: var(--app-text-sm); margin: 0; overflow-wrap: anywhere; }
  .pending-remits-mobile-card__details { border-top: 1px solid var(--app-color-border); padding: 10px; }
  .pending-remits-mobile-product { border-bottom: 1px solid var(--app-color-border); color: var(--app-color-text-secondary); display: grid; font-size: var(--app-text-sm); gap: 3px; padding: 8px 0; }
  .pending-remits-mobile-product:first-child { padding-top: 0; }
  .pending-remits-mobile-product:last-child { border-bottom: 0; padding-bottom: 0; }
  .pending-remits-mobile-product strong { color: var(--app-color-text); font-weight: var(--app-font-semibold); }
  @media (max-width: 991.98px) {
    .pending-remits-tree { max-height: 260px; }
    .pending-remits-tree-collapsed-bar { flex-direction: row; justify-content: center; margin: 0 15px 12px; min-height: 32px; padding: 6px 10px; width: calc(100% - 30px); }
    .pending-remits-tree-collapsed-bar > .material-symbols-rounded { margin: 0 5px 0 0; }
    .pending-remits-tree-collapsed-bar span { writing-mode: horizontal-tb; }
    .pending-remits-table-expanded { flex: 0 0 100%; max-width: 100%; }
  }
</style>
